var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"src":'https://storage.googleapis.com/commtool-6d611.appspot.com/image/edit_example.png'}})])}
var staticRenderFns = []

export { render, staticRenderFns }